import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-approval-form',
  templateUrl: './payment-approval-form.component.html',
  styleUrls: ['./payment-approval-form.component.css']
})
export class PaymentApprovalFormComponent implements OnInit {
  title="Payment Approval";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component.ts